// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AppDetail.module.css */
.AppDetail_mycontainer__xzggh {
  display: flex;
  width: 100%;
  overflow-x: hidden;
  height: 100%;
}
.AppDetail_sidebar-item__u1mdr {
  color: var(--subheading);
  align-items: center;
  /* padding: 10px; */
  gap: 0px;
  display: flex;
  cursor: pointer;
  justify-content: center;
  transition: all 0.3s ease;
  width: 100%;
}
.AppDetail_sidebar-item__u1mdr .AppDetail_active__XFcEt {
  background-color: var(--white-color);
  color: var(--secondary-color);
}
.AppDetail_sidebar-icon__Mh7p8 {
  font-size: 24px;
  align-items: center;
  display: flex;
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  min-width: 26px;
  margin-right: 8px;
}
/* Default icon color */
.AppDetail_sidebar-icon__Mh7p8 svg path {
  fill: var(--subheading) !important;
  stroke: transparent !important;
}

.AppDetail_sidebar-text__4PDEU {
  flex: 1 1;
  white-space: nowrap;
  word-break: break-word;
  font-size: 14px;
  font-weight: 500;
  opacity: 0;
  width: 0;
  overflow: hidden;
  transition:
    opacity 0.3s ease,
    width 0.3s ease;
  display: none;
}

.AppDetail_active__XFcEt {
  color: var(--bg-primary);
  background: var(--gradient-primary);
}
.AppDetail_active__XFcEt svg path {
  fill: var(--bg-primary) !important;
  stroke: transparent !important;
}
.AppDetail_sidebarheading__141DX {
  margin: 20px 0px 10px;
  font-size: 16px;
  font-weight: 500;
  color: var(--heading);
  opacity: 0;
  width: 0;
  overflow: hidden;
  white-space: nowrap;
  transition:
    opacity 0.3s ease,
    width 0.3s ease;
  padding: 0;
  margin: 0;
  height: 0;
}

.AppDetail_sidebar__Ghuxb {
  width: 80px;
  transition: width 0.3s ease;
  position: relative;
  height: 100%;
  overflow-y: hidden;
  background: var(--white-color);
}

.AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ {
  width: 250px;
}

.AppDetail_main-content__q6b2b {
  padding: 1.5rem 4rem;
  /* width: calc(100% - 80px); */
  text-align: center;
  overflow: auto;
  /* height: 97%; */
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease;
  width: 100%;
  margin: 1rem;
  border: 1px solid #ccc;
  border-radius: 10px;
  background: var(--gradient-bg);
}
.AppDetail_mainContentInnerWrap__ddgb9 {
  display: flex;
  flex-direction: column;
  margin: auto 0px;
}

.AppDetail_firstApp_created__RxJXu {
  color: var(--subheading);
  border-radius: 6px;
  margin: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  /* background: var(--bg-icon); */
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border);
}

.AppDetail_app_name__jh4WH {
  color: var(--subheading);
  margin-bottom: 0px;
  font-size: 0.9rem;
  font-weight: 500;
}
.AppDetail_firstApp_created__RxJXu p {
  font-size: 14px;
  font-weight: 400;
  color: var(--icon-bg-color);
}
.AppDetail_appUser_ids__w2IQo {
  color: var(--text-color);
  padding-top: 5px;
}
/* In UpdateSidebarMenu.module.css */

.AppDetail_sidebarList__ZGGU3 {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  overflow: hidden;
}

.AppDetail_groupedList__uOaAp {
  list-style: none;
  padding: 0;
  margin: 0;
  padding-left: 8px;
  width: 100%;
  overflow: hidden;
}

.AppDetail_groupedList__uOaAp li {
  padding-left: 4px;
}
.AppDetail_sidebar__Ghuxb a,
.AppDetail_sidebar__Ghuxb .AppDetail_dectoration__ouKAe,
.AppDetail_sidebar__Ghuxb a:link,
.AppDetail_sidebar__Ghuxb a:visited,
.AppDetail_sidebar__Ghuxb a:hover,
.AppDetail_sidebar__Ghuxb a:active {
  text-decoration: none !important;
}

/* Specifically target the Link component */
.AppDetail_sidebar__Ghuxb [class*="dectoration"] {
  text-decoration: none !important;
}
.AppDetail_groupedList__uOaAp .AppDetail_dectoration__ouKAe {
  display: block;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.AppDetail_dectoration__ouKAe {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 4px;
  transition:
    background-color 0.2s,
    padding 0.3s ease;
  text-decoration: none;
  color: var(--subheading);
  width: 100%;
  overflow: hidden;
  min-width: 0;
}

.AppDetail_dectoration__ouKAe:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.AppDetail_groupedList__uOaAp .AppDetail_dectoration__ouKAe:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_sidebarList-data__6GYaU {
  display: flex;
  /* border: 2px solid green; */
}
.AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_globalSettingsWrapper__iTXFw {
  display: block;
}
.AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_apps__pedCc {
  display: block;
}
.AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_firstApp_created__RxJXu {
  display: block;
  margin-top: 60px;
}

.AppDetail_apps__pedCc {
  margin: 0px;
  margin-top: auto;
  padding: 12px;
  background: var(--gradient-hero);
  box-shadow:
    rgba(50, 50, 93, 0.25) 0px 50px 100px 20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px 20px;
}
.AppDetail_btn__S6NwF {
  background: var(--bg-primary);
  color: var(--primary-light);
  border-radius: 4px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  font-size: 18px;
  outline: none;
  border: none;
  cursor: pointer;
  font-weight: 600;
}
.AppDetail_btn__S6NwF svg {
  display: none;
}
.AppDetail_globalSettingsWrapper__iTXFw {
  /* border: 5px solid #8360a1; */
  background-color: var(--bg-icon);
  padding-top: 5px;
}
.AppDetail_admin-sidebar__uzG0a {
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.AppDetail_admin-sidebar__uzG0a ul {
  list-style: none;
  padding: 0;
  /* margin: 0px 16px; */
  border-radius: 8px;
}

/* Admin chat side bar */

.AppDetail_sidebar-mainContainer__xTdk1 {
  display: flex;
  /* min-height: 80vh; */
  width: 100%;
  height: 100%;
}
.AppDetail_rootMainContant__8aq1H {
  padding: 1.8rem 2rem;
  width: 100%;
}

.AppDetail_adminwrapper__5sO1r {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
}
.AppDetail_adminAppId__6pyxH {
  color: var(--subheading);
  border-radius: 6px;
  margin: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border);
}
.AppDetail_adminAppId__6pyxH h3 {
  color: var(--subheading);
  margin-bottom: 0px;
  font-size: 0.9rem;
  font-weight: 500;
}
.AppDetail_adminAppId__6pyxH p {
  font-size: 14px;
  font-weight: 400;
  color: var(--subheading);
}
.AppDetail_admin-sidebar__uzG0a {
  background: var(--secondary-color);
  background: var(--white-color);

  /* height: 100%; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.AppDetail_admin-sidebar__uzG0a ul {
  list-style: none;
  padding: 0;
  /* margin: 0px 16px; */
  border-radius: 8px;
}
.AppDetail_sidebarBack__IV-ZB {
  position: absolute;
  /* top: 4%;
  right: -7%; */
  z-index: 5;
  transform: translateY(-50%);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--white-color);
  cursor: pointer;
  color: var(--subheading);
  display: none;
  align-items: center;
  justify-content: center;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border: 1px solid var(--subheading);
}
.AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ {
  width: 100%;
}
.AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_rootMainContant__8aq1H {
  display: block;
  margin-top: 60px;
}

.AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_adminAppId__6pyxH {
  display: block;
  margin-top: 60px;
}
.AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_sidebar-item__u1mdr {
  display: flex;
}
.AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_apps__pedCc {
  display: block;
}
.AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_admin-sidebar__uzG0a ul {
  display: block;
}

@media (max-width: 368px) {
  .AppDetail_sidebarBack__IV-ZB {
    width: 40px;
    height: 40px;
    font-size: 22px;
    top: 1%;
    right: 15px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    transform: translateX(16px);
    transform-origin: center;
  }
  .AppDetail_rootMainContant__8aq1H {
    padding: 0.5rem;
    width: 100%;
  }
  /* .apps {
    margin-bottom: 70px;
  } */
  .AppDetail_rotateOpen__zMTqI {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
    right: 2px;
    top: 10px;
  }

  .AppDetail_rotateClosed__OaavN {
    transform: rotate(0deg);
    transition: transform 0.3s ease;
    /* right: -5px; */
    right: -15px;
    top: 10px;
  }
  .AppDetail_sidebar-mainContainer__xTdk1 {
    overflow-y: hidden;
    touch-action: none;
  }
  .AppDetail_mainContentInnerWrap__ddgb9 {
    padding: 0px;
  }
}

@media (min-width: 769px) {
  .AppDetail_sidebar__Ghuxb:not(.AppDetail_open__KBsc\\+):hover {
    width: 250px !important;
    transition: width 0.3s ease;
  }

  .AppDetail_sidebar__Ghuxb:not(.AppDetail_open__KBsc\\+):hover .AppDetail_sidebar-text__4PDEU {
    opacity: 1 !important;
    width: auto !important;
    margin-left: 8px;
    transition:
      opacity 0.3s ease 0.1s,
      width 0.3s ease 0.1s;
    display: flex;
  }

  .AppDetail_sidebar__Ghuxb:not(.AppDetail_open__KBsc\\+):hover .AppDetail_btn__S6NwF svg {
    display: flex;
  }
  /* FIXED: Smooth heading reveal */
  .AppDetail_sidebar__Ghuxb:not(.AppDetail_open__KBsc\\+):hover .AppDetail_sidebarheading__141DX {
    opacity: 1 !important;
    width: auto !important;
    padding: 0 12px;
    margin: 20px 0px 10px;
    height: auto;
    transition:
      opacity 0.3s ease 0.15s,
      width 0.3s ease 0.15s,
      margin 0.3s ease 0.15s,
      height 0.3s ease 0.15s;
  }

  .AppDetail_sidebar__Ghuxb:not(.AppDetail_open__KBsc\\+):hover .AppDetail_sidebar-item__u1mdr {
    justify-content: flex-start;
    padding: 10px 12px;
    transition: padding 0.3s ease;
  }

  /* Adjust app info section when expanded */
  .AppDetail_sidebar__Ghuxb:not(.AppDetail_open__KBsc\\+):hover .AppDetail_firstApp_created__RxJXu {
    padding: 8px;
    transition: padding 0.3s ease;
  }

  .AppDetail_sidebar__Ghuxb:not(.AppDetail_open__KBsc\\+):hover .AppDetail_firstApp_created__RxJXu > div {
    opacity: 1 !important;
    width: auto !important;
    transition:
      opacity 0.3s ease 0.2s,
      width 0.3s ease 0.2s;
  }

  .AppDetail_sidebar__Ghuxb:not(.AppDetail_open__KBsc\\+) .AppDetail_firstApp_created__RxJXu > div {
    opacity: 0;
    width: 0;
    overflow: hidden;
    transition:
      opacity 0.3s ease,
      width 0.3s ease;
  }

  .AppDetail_sidebar__Ghuxb:not(.AppDetail_open__KBsc\\+) .AppDetail_firstApp_created__RxJXu {
    justify-content: center;
    padding: 8px 0;
  }

  /* When sidebar is manually opened */
  .AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_sidebar-text__4PDEU,
  .AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_sidebarheading__141DX,
  .AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_firstApp_created__RxJXu > div {
    opacity: 1 !important;
    width: auto !important;
    display: flex;
  }

  .AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_sidebar-text__4PDEU {
    margin-left: 8px;
  }

  .AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_sidebarheading__141DX {
    padding: 0 12px;
    margin: 20px 0px 10px;
    height: auto;
  }

  .AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_sidebar-item__u1mdr {
    justify-content: flex-start;
    padding: 14px 12px;
  }

  .AppDetail_sidebar__Ghuxb:not(.AppDetail_open__KBsc\\+):hover ~ .AppDetail_main-content__q6b2b {
    width: calc(100% - 250px) !important;
    transition: width 0.3s ease;
  }

  .AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ ~ .AppDetail_main-content__q6b2b {
    width: calc(100% - 250px) !important;
  }
  .AppDetail_mainContentInnerWrap__ddgb9 {
    padding: 16px;
  }
}

@media (max-width: 768px) {
  .AppDetail_sidebar__Ghuxb {
    width: 40px;
  }
  .AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ {
    width: 100%;
  }
  .AppDetail_sidebar__Ghuxb:not(.AppDetail_open__KBsc\\+) .AppDetail_sidebar-text__4PDEU {
    display: none;
  }
  .AppDetail_mainContentInnerWrap__ddgb9 {
    padding: 16px;
  }
  .AppDetail_sidebar__Ghuxb:not(.AppDetail_open__KBsc\\+) .AppDetail_sidebarheading__141DX {
    display: none;
  }
  .AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_btn__S6NwF svg {
    display: block;
  }
  .AppDetail_sidebar__Ghuxb.AppDetail_open__KBsc\\+ .AppDetail_sidebar-text__4PDEU {
    display: block;
    opacity: 1;
    width: 100%;
  }
  /* .sidebarBack {
    box-shadow: rgba(255, 255, 255, 0.608) 0px 7px 29px 0px;
    display: flex;
  } */
  .AppDetail_firstApp_created__RxJXu {
    display: none;
  }
  .AppDetail_sidebarList-data__6GYaU {
    display: none;
  }
  .AppDetail_globalSettingsWrapper__iTXFw {
    display: none;
  }
  .AppDetail_main-content__q6b2b.AppDetail_hidden__djVIc {
    display: none;
  }
  .AppDetail_main-content__q6b2b {
    padding: 1rem 0rem;
    width: calc(100% - 60px); /* Adjust for mobile sidebar width */
  }
  .AppDetail_rotateOpen__zMTqI {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
    right: -2px;
    top: 10px;
  }

  .AppDetail_rotateClosed__OaavN {
    transform: rotate(0deg);
    transition: transform 0.3s ease;
    right: -15px;
    top: 10px;
  }
  .AppDetail_apps__pedCc {
    display: none;
  }
  .AppDetail_rootMainContant__8aq1H.AppDetail_hidden__djVIc {
    display: none;
  }
  .AppDetail_adminAppId__6pyxH {
    display: none;
  }
  .AppDetail_sidebar-item__u1mdr {
    display: none;
  }
  .AppDetail_sidebarBack__IV-ZB {
    /* right: 25px; */
    box-shadow: rgba(255, 255, 255, 0.608) 0px 7px 29px 0px;
    display: flex;
  }

  .AppDetail_rootMainContant__8aq1H {
    padding: 1rem;
    width: 100%;
  }
  .AppDetail_sidebar-mainContainer__xTdk1 {
    overflow-y: hidden;
    touch-action: none;
  }
  .AppDetail_rotateOpen__zMTqI {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
    right: 2px;
    top: 10px;
  }

  .AppDetail_rotateClosed__OaavN {
    transform: rotate(0deg);
    transition: transform 0.3s ease;
    /* right: -5px; */
    right: -15px;
    top: 10px;
  }
}
@media (max-width: 368px) {
  .AppDetail_sidebarBack__IV-ZB {
    width: 40px;
    height: 40px;
    font-size: 22px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    transform: translateX(16px);
    transform-origin: center;
  }
  .AppDetail_main-content__q6b2b {
    padding: 0rem;
    width: 100%;
    overflow: hidden;
    height: 95%;
  }
  .AppDetail_mycontainer__xzggh {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .AppDetail_mycontainer__xzggh::-webkit-scrollbar {
    display: none;
  }
  .AppDetail_firstApp_created__RxJXu {
    margin: 0px;
  }
  .AppDetail_sidebarList-data__6GYaU {
    margin: 20px 0px;
  }
  .AppDetail_rotateOpen__zMTqI {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
    right: 0px;
    top: 10px;
  }

  .AppDetail_rotateClosed__OaavN {
    transform: rotate(0deg);
    transition: transform 0.3s ease;
    right: -15px;
    top: 10px;
  }
  .AppDetail_main-content__q6b2b {
    overflow-y: auto;
    margin-bottom: 50px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .AppDetail_main-contenty__wL-5k::-webkit-scrollbar {
    display: none;
  }
}
@media (max-width: 468px) {
  .AppDetail_main-content__q6b2b {
    padding: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AppDetail.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA,uBAAuB;AACvB;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB;;mBAEiB;EACjB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;AACrC;AACA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB;;mBAEiB;EACjB,UAAU;EACV,SAAS;EACT,SAAS;AACX;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA,oCAAoC;;AAEpC;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;;;;;;EAME,gCAAgC;AAClC;;AAEA,2CAA2C;AAC3C;EACE,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB;;qBAEmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC;;yCAEuC;AACzC;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,eAAe;EACf,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,wBAAwB;;AAExB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,kCAAkC;EAClC,8BAA8B;;EAE9B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB;eACa;EACb,UAAU;EACV,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,mCAAmC;AACrC;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,OAAO;IACP,WAAW;IACX,4CAA4C;IAC5C,2BAA2B;IAC3B,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;;KAEG;EACH;IACE,yBAAyB;IACzB,+BAA+B;IAC/B,UAAU;IACV,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,+BAA+B;IAC/B,iBAAiB;IACjB,YAAY;IACZ,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB;;0BAEsB;IACtB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;EACA,iCAAiC;EACjC;IACE,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ;;;;4BAIwB;EAC1B;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA,0CAA0C;EAC1C;IACE,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB;;0BAEsB;EACxB;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,gBAAgB;IAChB;;qBAEiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,cAAc;EAChB;;EAEA,oCAAoC;EACpC;;;IAGE,qBAAqB;IACrB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;IACpC,2BAA2B;EAC7B;;EAEA;IACE,oCAAoC;EACtC;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,UAAU;IACV,WAAW;EACb;EACA;;;KAGG;EACH;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,wBAAwB,EAAE,oCAAoC;EAChE;EACA;IACE,yBAAyB;IACzB,+BAA+B;IAC/B,WAAW;IACX,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,+BAA+B;IAC/B,YAAY;IACZ,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,uDAAuD;IACvD,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,+BAA+B;IAC/B,UAAU;IACV,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,+BAA+B;IAC/B,iBAAiB;IACjB,YAAY;IACZ,SAAS;EACX;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,4CAA4C;IAC5C,2BAA2B;IAC3B,wBAAwB;EAC1B;EACA;IACE,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,+BAA+B;IAC/B,UAAU;IACV,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,+BAA+B;IAC/B,YAAY;IACZ,SAAS;EACX;EACA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,qBAAqB;IACrB,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["/* AppDetail.module.css */\n.mycontainer {\n  display: flex;\n  width: 100%;\n  overflow-x: hidden;\n  height: 100%;\n}\n.sidebar-item {\n  color: var(--subheading);\n  align-items: center;\n  /* padding: 10px; */\n  gap: 0px;\n  display: flex;\n  cursor: pointer;\n  justify-content: center;\n  transition: all 0.3s ease;\n  width: 100%;\n}\n.sidebar-item .active {\n  background-color: var(--white-color);\n  color: var(--secondary-color);\n}\n.sidebar-icon {\n  font-size: 24px;\n  align-items: center;\n  display: flex;\n  width: 26px;\n  height: 26px;\n  flex-shrink: 0;\n  min-width: 26px;\n  margin-right: 8px;\n}\n/* Default icon color */\n.sidebar-icon svg path {\n  fill: var(--subheading) !important;\n  stroke: transparent !important;\n}\n\n.sidebar-text {\n  flex: 1;\n  white-space: nowrap;\n  word-break: break-word;\n  font-size: 14px;\n  font-weight: 500;\n  opacity: 0;\n  width: 0;\n  overflow: hidden;\n  transition:\n    opacity 0.3s ease,\n    width 0.3s ease;\n  display: none;\n}\n\n.active {\n  color: var(--bg-primary);\n  background: var(--gradient-primary);\n}\n.active svg path {\n  fill: var(--bg-primary) !important;\n  stroke: transparent !important;\n}\n.sidebarheading {\n  margin: 20px 0px 10px;\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--heading);\n  opacity: 0;\n  width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  transition:\n    opacity 0.3s ease,\n    width 0.3s ease;\n  padding: 0;\n  margin: 0;\n  height: 0;\n}\n\n.sidebar {\n  width: 80px;\n  transition: width 0.3s ease;\n  position: relative;\n  height: 100%;\n  overflow-y: hidden;\n  background: var(--white-color);\n}\n\n.sidebar.open {\n  width: 250px;\n}\n\n.main-content {\n  padding: 1.5rem 4rem;\n  /* width: calc(100% - 80px); */\n  text-align: center;\n  overflow: auto;\n  /* height: 97%; */\n  display: flex;\n  flex-direction: column;\n  transition: width 0.3s ease;\n  width: 100%;\n  margin: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  background: var(--gradient-bg);\n}\n.mainContentInnerWrap {\n  display: flex;\n  flex-direction: column;\n  margin: auto 0px;\n}\n\n.firstApp_created {\n  color: var(--subheading);\n  border-radius: 6px;\n  margin: 8px;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  transition: all 0.3s ease;\n  /* background: var(--bg-icon); */\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border);\n}\n\n.app_name {\n  color: var(--subheading);\n  margin-bottom: 0px;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n.firstApp_created p {\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--icon-bg-color);\n}\n.appUser_ids {\n  color: var(--text-color);\n  padding-top: 5px;\n}\n/* In UpdateSidebarMenu.module.css */\n\n.sidebarList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  overflow: hidden;\n}\n\n.groupedList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  padding-left: 8px;\n  width: 100%;\n  overflow: hidden;\n}\n\n.groupedList li {\n  padding-left: 4px;\n}\n.sidebar a,\n.sidebar .dectoration,\n.sidebar a:link,\n.sidebar a:visited,\n.sidebar a:hover,\n.sidebar a:active {\n  text-decoration: none !important;\n}\n\n/* Specifically target the Link component */\n.sidebar [class*=\"dectoration\"] {\n  text-decoration: none !important;\n}\n.groupedList .dectoration {\n  display: block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n.dectoration {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  border-radius: 4px;\n  transition:\n    background-color 0.2s,\n    padding 0.3s ease;\n  text-decoration: none;\n  color: var(--subheading);\n  width: 100%;\n  overflow: hidden;\n  min-width: 0;\n}\n\n.dectoration:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.groupedList .dectoration:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.sidebar.open .sidebarList-data {\n  display: flex;\n  /* border: 2px solid green; */\n}\n.sidebar.open .globalSettingsWrapper {\n  display: block;\n}\n.sidebar.open .apps {\n  display: block;\n}\n.sidebar.open .firstApp_created {\n  display: block;\n  margin-top: 60px;\n}\n\n.apps {\n  margin: 0px;\n  margin-top: auto;\n  padding: 12px;\n  background: var(--gradient-hero);\n  box-shadow:\n    rgba(50, 50, 93, 0.25) 0px 50px 100px 20px,\n    rgba(0, 0, 0, 0.3) 0px 30px 60px 20px;\n}\n.btn {\n  background: var(--bg-primary);\n  color: var(--primary-light);\n  border-radius: 4px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  font-size: 18px;\n  outline: none;\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n}\n.btn svg {\n  display: none;\n}\n.globalSettingsWrapper {\n  /* border: 5px solid #8360a1; */\n  background-color: var(--bg-icon);\n  padding-top: 5px;\n}\n.admin-sidebar {\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n.admin-sidebar ul {\n  list-style: none;\n  padding: 0;\n  /* margin: 0px 16px; */\n  border-radius: 8px;\n}\n\n/* Admin chat side bar */\n\n.sidebar-mainContainer {\n  display: flex;\n  /* min-height: 80vh; */\n  width: 100%;\n  height: 100%;\n}\n.rootMainContant {\n  padding: 1.8rem 2rem;\n  width: 100%;\n}\n\n.adminwrapper {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  height: 100%;\n}\n.adminAppId {\n  color: var(--subheading);\n  border-radius: 6px;\n  margin: 8px;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  transition: all 0.3s ease;\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border);\n}\n.adminAppId h3 {\n  color: var(--subheading);\n  margin-bottom: 0px;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n.adminAppId p {\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--subheading);\n}\n.admin-sidebar {\n  background: var(--secondary-color);\n  background: var(--white-color);\n\n  /* height: 100%; */\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.admin-sidebar ul {\n  list-style: none;\n  padding: 0;\n  /* margin: 0px 16px; */\n  border-radius: 8px;\n}\n.sidebarBack {\n  position: absolute;\n  /* top: 4%;\n  right: -7%; */\n  z-index: 5;\n  transform: translateY(-50%);\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: var(--white-color);\n  cursor: pointer;\n  color: var(--subheading);\n  display: none;\n  align-items: center;\n  justify-content: center;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  border: 1px solid var(--subheading);\n}\n.sidebar.open {\n  width: 100%;\n}\n.sidebar.open .rootMainContant {\n  display: block;\n  margin-top: 60px;\n}\n\n.sidebar.open .adminAppId {\n  display: block;\n  margin-top: 60px;\n}\n.sidebar.open .sidebar-item {\n  display: flex;\n}\n.sidebar.open .apps {\n  display: block;\n}\n.sidebar.open .admin-sidebar ul {\n  display: block;\n}\n\n@media (max-width: 368px) {\n  .sidebarBack {\n    width: 40px;\n    height: 40px;\n    font-size: 22px;\n    top: 1%;\n    right: 15px;\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n    transform: translateX(16px);\n    transform-origin: center;\n  }\n  .rootMainContant {\n    padding: 0.5rem;\n    width: 100%;\n  }\n  /* .apps {\n    margin-bottom: 70px;\n  } */\n  .rotateOpen {\n    transform: rotate(180deg);\n    transition: transform 0.3s ease;\n    right: 2px;\n    top: 10px;\n  }\n\n  .rotateClosed {\n    transform: rotate(0deg);\n    transition: transform 0.3s ease;\n    /* right: -5px; */\n    right: -15px;\n    top: 10px;\n  }\n  .sidebar-mainContainer {\n    overflow-y: hidden;\n    touch-action: none;\n  }\n  .mainContentInnerWrap {\n    padding: 0px;\n  }\n}\n\n@media (min-width: 769px) {\n  .sidebar:not(.open):hover {\n    width: 250px !important;\n    transition: width 0.3s ease;\n  }\n\n  .sidebar:not(.open):hover .sidebar-text {\n    opacity: 1 !important;\n    width: auto !important;\n    margin-left: 8px;\n    transition:\n      opacity 0.3s ease 0.1s,\n      width 0.3s ease 0.1s;\n    display: flex;\n  }\n\n  .sidebar:not(.open):hover .btn svg {\n    display: flex;\n  }\n  /* FIXED: Smooth heading reveal */\n  .sidebar:not(.open):hover .sidebarheading {\n    opacity: 1 !important;\n    width: auto !important;\n    padding: 0 12px;\n    margin: 20px 0px 10px;\n    height: auto;\n    transition:\n      opacity 0.3s ease 0.15s,\n      width 0.3s ease 0.15s,\n      margin 0.3s ease 0.15s,\n      height 0.3s ease 0.15s;\n  }\n\n  .sidebar:not(.open):hover .sidebar-item {\n    justify-content: flex-start;\n    padding: 10px 12px;\n    transition: padding 0.3s ease;\n  }\n\n  /* Adjust app info section when expanded */\n  .sidebar:not(.open):hover .firstApp_created {\n    padding: 8px;\n    transition: padding 0.3s ease;\n  }\n\n  .sidebar:not(.open):hover .firstApp_created > div {\n    opacity: 1 !important;\n    width: auto !important;\n    transition:\n      opacity 0.3s ease 0.2s,\n      width 0.3s ease 0.2s;\n  }\n\n  .sidebar:not(.open) .firstApp_created > div {\n    opacity: 0;\n    width: 0;\n    overflow: hidden;\n    transition:\n      opacity 0.3s ease,\n      width 0.3s ease;\n  }\n\n  .sidebar:not(.open) .firstApp_created {\n    justify-content: center;\n    padding: 8px 0;\n  }\n\n  /* When sidebar is manually opened */\n  .sidebar.open .sidebar-text,\n  .sidebar.open .sidebarheading,\n  .sidebar.open .firstApp_created > div {\n    opacity: 1 !important;\n    width: auto !important;\n    display: flex;\n  }\n\n  .sidebar.open .sidebar-text {\n    margin-left: 8px;\n  }\n\n  .sidebar.open .sidebarheading {\n    padding: 0 12px;\n    margin: 20px 0px 10px;\n    height: auto;\n  }\n\n  .sidebar.open .sidebar-item {\n    justify-content: flex-start;\n    padding: 14px 12px;\n  }\n\n  .sidebar:not(.open):hover ~ .main-content {\n    width: calc(100% - 250px) !important;\n    transition: width 0.3s ease;\n  }\n\n  .sidebar.open ~ .main-content {\n    width: calc(100% - 250px) !important;\n  }\n  .mainContentInnerWrap {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .sidebar {\n    width: 40px;\n  }\n  .sidebar.open {\n    width: 100%;\n  }\n  .sidebar:not(.open) .sidebar-text {\n    display: none;\n  }\n  .mainContentInnerWrap {\n    padding: 16px;\n  }\n  .sidebar:not(.open) .sidebarheading {\n    display: none;\n  }\n  .sidebar.open .btn svg {\n    display: block;\n  }\n  .sidebar.open .sidebar-text {\n    display: block;\n    opacity: 1;\n    width: 100%;\n  }\n  /* .sidebarBack {\n    box-shadow: rgba(255, 255, 255, 0.608) 0px 7px 29px 0px;\n    display: flex;\n  } */\n  .firstApp_created {\n    display: none;\n  }\n  .sidebarList-data {\n    display: none;\n  }\n  .globalSettingsWrapper {\n    display: none;\n  }\n  .main-content.hidden {\n    display: none;\n  }\n  .main-content {\n    padding: 1rem 0rem;\n    width: calc(100% - 60px); /* Adjust for mobile sidebar width */\n  }\n  .rotateOpen {\n    transform: rotate(180deg);\n    transition: transform 0.3s ease;\n    right: -2px;\n    top: 10px;\n  }\n\n  .rotateClosed {\n    transform: rotate(0deg);\n    transition: transform 0.3s ease;\n    right: -15px;\n    top: 10px;\n  }\n  .apps {\n    display: none;\n  }\n  .rootMainContant.hidden {\n    display: none;\n  }\n  .adminAppId {\n    display: none;\n  }\n  .sidebar-item {\n    display: none;\n  }\n  .sidebarBack {\n    /* right: 25px; */\n    box-shadow: rgba(255, 255, 255, 0.608) 0px 7px 29px 0px;\n    display: flex;\n  }\n\n  .rootMainContant {\n    padding: 1rem;\n    width: 100%;\n  }\n  .sidebar-mainContainer {\n    overflow-y: hidden;\n    touch-action: none;\n  }\n  .rotateOpen {\n    transform: rotate(180deg);\n    transition: transform 0.3s ease;\n    right: 2px;\n    top: 10px;\n  }\n\n  .rotateClosed {\n    transform: rotate(0deg);\n    transition: transform 0.3s ease;\n    /* right: -5px; */\n    right: -15px;\n    top: 10px;\n  }\n}\n@media (max-width: 368px) {\n  .sidebarBack {\n    width: 40px;\n    height: 40px;\n    font-size: 22px;\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n    transform: translateX(16px);\n    transform-origin: center;\n  }\n  .main-content {\n    padding: 0rem;\n    width: 100%;\n    overflow: hidden;\n    height: 95%;\n  }\n  .mycontainer {\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n  .mycontainer::-webkit-scrollbar {\n    display: none;\n  }\n  .firstApp_created {\n    margin: 0px;\n  }\n  .sidebarList-data {\n    margin: 20px 0px;\n  }\n  .rotateOpen {\n    transform: rotate(180deg);\n    transition: transform 0.3s ease;\n    right: 0px;\n    top: 10px;\n  }\n\n  .rotateClosed {\n    transform: rotate(0deg);\n    transition: transform 0.3s ease;\n    right: -15px;\n    top: 10px;\n  }\n  .main-content {\n    overflow-y: auto;\n    margin-bottom: 50px;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n  .main-contenty::-webkit-scrollbar {\n    display: none;\n  }\n}\n@media (max-width: 468px) {\n  .main-content {\n    padding: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mycontainer": `AppDetail_mycontainer__xzggh`,
	"sidebar-item": `AppDetail_sidebar-item__u1mdr`,
	"active": `AppDetail_active__XFcEt`,
	"sidebar-icon": `AppDetail_sidebar-icon__Mh7p8`,
	"sidebar-text": `AppDetail_sidebar-text__4PDEU`,
	"sidebarheading": `AppDetail_sidebarheading__141DX`,
	"sidebar": `AppDetail_sidebar__Ghuxb`,
	"open": `AppDetail_open__KBsc+`,
	"main-content": `AppDetail_main-content__q6b2b`,
	"mainContentInnerWrap": `AppDetail_mainContentInnerWrap__ddgb9`,
	"firstApp_created": `AppDetail_firstApp_created__RxJXu`,
	"app_name": `AppDetail_app_name__jh4WH`,
	"appUser_ids": `AppDetail_appUser_ids__w2IQo`,
	"sidebarList": `AppDetail_sidebarList__ZGGU3`,
	"groupedList": `AppDetail_groupedList__uOaAp`,
	"dectoration": `AppDetail_dectoration__ouKAe`,
	"sidebarList-data": `AppDetail_sidebarList-data__6GYaU`,
	"globalSettingsWrapper": `AppDetail_globalSettingsWrapper__iTXFw`,
	"apps": `AppDetail_apps__pedCc`,
	"btn": `AppDetail_btn__S6NwF`,
	"admin-sidebar": `AppDetail_admin-sidebar__uzG0a`,
	"sidebar-mainContainer": `AppDetail_sidebar-mainContainer__xTdk1`,
	"rootMainContant": `AppDetail_rootMainContant__8aq1H`,
	"adminwrapper": `AppDetail_adminwrapper__5sO1r`,
	"adminAppId": `AppDetail_adminAppId__6pyxH`,
	"sidebarBack": `AppDetail_sidebarBack__IV-ZB`,
	"rotateOpen": `AppDetail_rotateOpen__zMTqI`,
	"rotateClosed": `AppDetail_rotateClosed__OaavN`,
	"hidden": `AppDetail_hidden__djVIc`,
	"main-contenty": `AppDetail_main-contenty__wL-5k`
};
export default ___CSS_LOADER_EXPORT___;
